<template>
  <div v-loading="maLoading"  style="width: 100%; min-height: 700px">

    <section class="formulaBox">       
        <div><i>Bitcoin Investor Tool = MA<span><i>730</i> </span> (BTC<span ><i>USD</i></span>) and MA<span>730*5</span> (BTC<span>USD</span> )</i></div>
      </section>


       <!-- 对数线性显示切换 -->
    <!-- <el-row>
      <el-col>    
         <el-button @click="handelLineSwitch"
         style="margin-left:100px;height:35px;border-radius:6px;"
         >{{ $t(`home.switch`)
          }}<span class="according"> {{ $t(switch3) }}</span></el-button
        >
      </el-col>
    </el-row> -->
    <el-row>
      <el-col :span="24">
        <h3 class="maTillte">{{$t(`arh.ma370`)}}</h3>
        <div style="padding-left: 9%;font-size:12px;color:rgba(0,0,0,0.6);margin-top: 10px;">{{ $t(`home.figure`) }}</div>

        <div
          id="maBox"
          style="width: 100%; min-height: 700px"
        ></div>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <h3 class="maTillte">{{$t(`arh.dayGraph`)}}</h3>
        <div style="padding-left: 9%;font-size:12px;color:rgba(0,0,0,0.6);margin-top: 10px;">{{ $t(`home.figure2`) }}</div>

        <div
          id="maDayBox"
          style="width: 100%; min-height: 700px"
        ></div>
      </el-col>
    </el-row>
      <!-- <section class="formulaBox">
        <p>{{  $t(`home.formula`) }}</p>
        <div>Bitcoin Investor Tool = MA<span>730</span>(BTC<span>USD</span>) and MA<span>730*5</span> (BTC<span>USD</span> )</div>

      </section> -->

  </div>
</template>

<script>
import IndexJs from "./index";
export default {
  mixins: [IndexJs],
};
</script>

<style lang="scss" scoped>
.maTillte {
  margin-left: 45%;
  color: rgba(0, 0, 0, 0.6);
}
.formulaBox{
  width: 98.7%;
  padding: 10px 0px;
  margin-bottom: -30px;
  font-size: 18px;
  // height: 60px;
  // background: #e5e5e5;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  font-weight: 600;

  p{
    padding: 0px 10px;
  }
  div{
    padding: 0px 10px;
    span{
      font-size: 12px;
    }

  }


}

</style>